<template>
  <div class="allcountries" v-if="showCountries">
    <div>
      <div class="container pop">
        <icon-x class="close" @click="toggleCountries" />
        <h3>{{ $t("discover.by_country.title") }}</h3>
        <p>{{ $t("discover.by_country.subtitle") }}</p>
        <div class="row justify-content-center">
          <router-link 
                v-for="(country, i) in countries"
                v-bind:key="i"
                :to="{
                  path:
                    (
                      locale === 'es'
                      ? `/es/descubre/`
                      : `/en/discover/`
                    )+(selectedCountry !== country ? country.slug : ''),
                }"
                :class="{'selected': (selectedCountry === country)}"
                class="country-col col">
              <country-flag
                :country-flag="country.rounded"
                :country-name="country.title"
              ></country-flag>
              <span class="country-name">
                {{country.name}}
              </span>
            </router-link>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-10 by-country">
        <div>
          <button class="btn btn-link right p-0 p-md-1" @click="toggleCountries">
            {{ $t("discover.by_country.view_all") }}
          </button>
          <h4>{{ $t("discover.by_country.title") }}</h4>
          <p>{{ $t("discover.by_country.subtitle") }}</p>

          <div class="row justify-content-center">

            <router-link 
                v-for="(country, i) in countriesList"
                v-bind:key="i"
                :to="{
                  path:
                    (
                      locale === 'es'
                      ? `/es/descubre/`
                      : `/en/discover/`
                    )+ (selectedCountry !== country ? country.slug : ''),
                }"
                :class="{'selected': (selectedCountry === country)}"
                class="country-col col">
              <country-flag
                :country-flag="country.rounded"
                :country-name="country.title"
              ></country-flag>
              <span class="country-name">
                {{country.name}}
              </span>
            </router-link>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountryFlag from "@/components/icons/CountryFlag.vue";
import IconX from "@/components/icons/iconX.vue";
import { UserStore } from "@/stores/userStore";
import { mapState } from "pinia";
import { UIStore } from "../../stores/uiStore";

export default {
  name: "BrowseByCountry",
  components: { IconX, CountryFlag },
  props: {
    countries: {
      type: Array,
      default: () => [],
    },
    selectedCountry: {
      type: Object,
      required: false,
    }
  },
  computed: {
    ...mapState(UIStore, ["getCurrentWidth"]),
    countriesList() {
      let length = this.$breakpoints("country_list", this.getCurrentWidth);
      return this.countries.slice(0, length);
    },
    locale() {
      const userStore = UserStore();
      return userStore.getLanguage;
    },
  },
  methods: {
    toggleCountries() {
      this.showCountries = !this.showCountries;
    },
  },
  watch:{
    selectedCountry(value){
      this.showCountries = false;
    }
  },  
  data() {
    return {
      showCountries: false,
    };
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";

.allcountries {
  position: fixed;
  top: 0;
  left: 0;
  padding: 5em 0;
  height: 100vh;
  width: 100vw;
  background: #0c121d99;
  z-index: 99;
  overflow: auto;

  & > div > .container {
    &.pop {
      background: url("@/assets/img/discover/all_countries.jpg") no-repeat
        center center;
      background-size: cover;
      z-index: 109;
      width: 90%;
      max-width: 500px;
      display: block;
      margin: 0 auto;
      border-radius: 32px;
      padding: 1em 2em 1em;

      a {
        text-decoration: none;
      }
      h3,
      p {
        text-align: center;
      }

      .close {
        float: right;
      }
    }
  }
  .country-col{
    padding: 1em;
    .country-name{
      color: $white;
      text-align: center;
      width: 100%;
      display: block;
    }
  }
}
.by-country {
  position: relative;
  z-index: 1;
  margin: 3em auto 0;
  background: linear-gradient(to bottom right, #101727, #ffffff);
  backdrop-filter: blur(16px);
  border-radius: 16px;
  opacity: 0.9;
  padding: 0.5px;
  > div {
    width: 100%;
    background: #131a29;
    padding: 1em;
    border-radius: 16px;
  }
  .right {
    float: right;
    color: $gray-3;
  }
  h4 {
    font-size: 1em;
    font-weight: bold;
  }
  .btn{
    font-size: 0.9em;
  }
  p {
    font-weight: lighter;
    font-size: 0.9em;
  }
  a {
    text-decoration: none;
  }
  .country-col{
    padding: 1em;
    .country-name{
      color: $white;
      text-align: center;
      width: 100%;
      display: block;
    }
    &.selected{
      .country-name{
        font-weight: bold;
      } 
      .flag{
        border: 3px solid $red;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-image: url('@/assets/img/check-circle.svg');
          background-repeat: no-repeat;
          background-size: contain;
          height: 45%;
          width: 45%;
          display: block;
        }
        &::before{
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 100%;
          background-color: rgb(12 17 27 / 70%);
          height: 100%;
          width: 100%;
          display: block;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .by-country {
    > div {
      padding: 2em;
    }
  }
}


@media (min-width: 1920px) {

  .by-country {
    
    h4 {
      font-size: 1.1vw;
    }
    p {
      font-size: 0.8vw;
    }
  }
}

@media (min-width: 3840px) {

  .by-country {
    h4 {
      font-size: 2.2em;
    }
    p {
      font-size: 1.4em;
    }
  }
}



</style>
